import './WorkPointsRulesModal.scss';
import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { S_InfoModal } from '../../../../../../design/modals/infoModal/S_InfoModal';
import { ColumnLayout } from '../../../../../common/layouts/columnLayout/ColumnLayout';

interface IProps {
  show: boolean;
  toggle: () => void;
}

export const WorkPointsRulesModal = ({ show, toggle }: IProps): ReactElement => {
  const { t } = useTranslator();
  const header = t('projects.details.stats.annotation_tools.rules_modal.header');
  const ok = t('projects.details.stats.annotation_tools.rules_modal.ok');

  return (
    <S_InfoModal
      isOpen={show}
      buttonText={ok}
      headerText={header}
      onClick={toggle}
      toggle={toggle}
    >
      <ColumnLayout
        size='md'
        className='work-points-rules-modal'
      >
        <div>
          <div>{t('projects.details.stats.annotation_tools.rules_modal.description')}</div>
          <div>{t('projects.details.stats.annotation_tools.rules_modal.description2')}</div>
        </div>
        <div>
          <h5 className='rules-modal-header'>{t('projects.details.stats.annotation_tools.rules_modal.marking_tools')}</h5>
          <ul className='rules-list'>
            <li>{t('projects.details.stats.annotation_tools.rules_modal.bounding_box')}</li>
            <li>{t('projects.details.stats.annotation_tools.rules_modal.brush')}</li>
            <li>{t('projects.details.stats.annotation_tools.rules_modal.line')}</li>
            <li>{t('projects.details.stats.annotation_tools.rules_modal.oriented_rectangle')}</li>
            <li>{t('projects.details.stats.annotation_tools.rules_modal.point')}</li>
            <li>{t('projects.details.stats.annotation_tools.rules_modal.polygon')}</li>
            <li>{t('projects.details.stats.annotation_tools.rules_modal.vector')}</li>
          </ul>
        </div>
        <div>
          <h5 className='rules-modal-header'>{t('projects.details.stats.annotation_tools.rules_modal.attributes_and_questions')}</h5>
          <ul className='rules-list'>
            <li>{t('projects.details.stats.annotation_tools.rules_modal.yes_no')}</li>
            <li>{t('projects.details.stats.annotation_tools.rules_modal.radio')}</li>
            <li>{t('projects.details.stats.annotation_tools.rules_modal.checkbox')}</li>
            <li>{t('projects.details.stats.annotation_tools.rules_modal.text')}</li>
            <li>{t('projects.details.stats.annotation_tools.rules_modal.number')}</li>
            <li>{t('projects.details.stats.annotation_tools.rules_modal.pass_fail')}</li>
            <li>{t('projects.details.stats.annotation_tools.rules_modal.train_test')}</li>
          </ul>
        </div>
      </ColumnLayout>
    </S_InfoModal>
  );
};
